import React from 'react'
import './HomeHeader.css'
import {useNavigate} from 'react-router-dom'
import { useLocation } from 'react-router-dom';
function HomeHeader() {
    const navigate=useNavigate()
    let location = useLocation();
    const [active,setactive]=React.useState('swap')
    React.useEffect(()=>
    {
        console.log(location.pathname)
    })
  return (
    <div className='Home-header'>
        <div className='header-left-logo'>
            <img src='/assets/Logo.png' />
            </div>
            <div className='header-right-logo' onClick={()=>navigate('/swap')}>
            <img src='/assets/eggheadstore.png'/>
       
            </div>
      
    </div>
  )
}

export default HomeHeader